import React from 'react';
import P from 'prop-types';
import './styles.css';
import { FormataValor } from '../../utils/utils';

export const ValoresTotais = ({
  origin = 'modal',
  taxa_text = '',
  subtotal = 0,
  taxa = 0,
  total = 0,
  acrescimo = 0,
  desconto = 0,
  isDelivery = true,
}) => {
  return (
    <div
      className="box_order"
      style={{
        boxShadow: 'none',
        borderRadius: '0',
        padding: '0px',
        marginBottom: '0px',
        borderBottom: `${origin == 'desktop' ? '' : ''}`,
        //borderBottom: `${origin == 'desktop' ? '1px solid #ebebeb' : ''}`,
      }}
    >
      <div className="main" style={{ padding: '0px', overflow: 'hidden' }}>
        <ul className="clearfix" style={{ paddingTop: '10px', paddingBottom: '0px' }}>
          <li>
            Subtotal<span>{FormataValor(subtotal)}</span>
          </li>

          {desconto > 0 && (
            <li>
              Desconto<span>{FormataValor(desconto)}</span>
            </li>
          )}

          {acrescimo > 0 && (
            <li>
              Acréscimo<span>{FormataValor(acrescimo)}</span>
            </li>
          )}

          <li>
            {isDelivery ? 'Taxa' : 'Serviço'} <span>{taxa_text != '' ? taxa_text : FormataValor(taxa)}</span>
          </li>

          <li className="total">
            Total<span>{FormataValor(total)}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

ValoresTotais.propTypes = {
  origin: P.string,
  taxa_text: P.oneOfType([P.string, P.bool]),
  subtotal: P.number.isRequired,
  taxa: P.oneOfType([P.string, P.number]),
  total: P.number.isRequired,
  desconto: P.number,
  acrescimo: P.number,
  isDelivery: P.bool,
};
